module.exports = __webpack_public_path__ + "media/src/public/img/payment/phone-4b80922d55be0a94bb86aca751e732f7.png";